import React from 'react';
import { BaseEdge, getBezierEdgeCenter } from '@xyflow/react';
import type { EdgeProps } from '@xyflow/react';

export default function CurvedEdge(props: EdgeProps) {
  const { sourceX, sourceY, targetX, targetY } = props;
  const diff = sourceY > targetY ? sourceY - targetY : targetY - sourceY;
  const qY = diff * 0.2 * (sourceY > targetY ? -1 : 1);
  const q = diff * 0.2;
  const [labelX, labelY] = getBezierEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourceControlX: sourceX - q,
    sourceControlY: sourceY + q,
    targetControlX: targetX - q,
    targetControlY: targetY - q,
  });

  const edgePath = `M ${sourceX} ${sourceY} C ${sourceX - q} ${sourceY + qY} ${
    targetX - q
  } ${targetY - qY} ${targetX} ${targetY}`;

  return <BaseEdge {...props} labelX={labelX} labelY={labelY} path={edgePath} />;
}
